// Precision Contracting Network — professional TEXT wordmark
// Clean, corporate, navy + gold. Two sizes: "compact" (nav) and "stacked" (footer/hero).
//
// Design choices:
// - "PRECISION" is the memorable anchor — heaviest weight, white.
// - Gold hairline separator + spaced "CONTRACTING NETWORK" underneath.
// - Optional micro-legal line "COMPANY W.L.L".

export default function BrandWordmark({
  variant = "compact",   // "compact" | "stacked"
  onDark = true,         // true → navy background, false → white background
  showLegal = false,     // include "COMPANY W.L.L" micro tagline
  className = "",
}) {
  const primary = onDark ? "text-white" : "text-[#0A1F44]";
  const gold = "text-[#C9A84C]";
  const hairline = onDark ? "bg-[#C9A84C]" : "bg-[#C9A84C]";

  if (variant === "stacked") {
    return (
      <div className={`inline-flex flex-col leading-none ${className}`} aria-label="Precision Contracting Network Company W.L.L">
        <span className={`font-display font-bold uppercase tracking-tight text-3xl md:text-4xl ${primary}`}>
          Precision
        </span>
        <div className="flex items-center gap-3 mt-2">
          <span className={`inline-block h-px w-8 ${hairline}`} />
          <span className={`font-display font-semibold uppercase tracking-[0.28em] text-xs md:text-sm ${gold}`}>
            Contracting Network
          </span>
        </div>
        {showLegal && (
          <span className={`font-mono uppercase tracking-[0.3em] text-[10px] mt-3 ${onDark ? "text-white/50" : "text-[#0A1F44]/50"}`}>
            Company W.L.L · Bahrain
          </span>
        )}
      </div>
    );
  }

  // compact — for navbars, admin headers, chat headers
  return (
    <div className={`inline-flex flex-col leading-none ${className}`} aria-label="Precision Contracting Network Company W.L.L">
      <span className={`font-display font-bold uppercase tracking-tight text-lg md:text-xl ${primary}`}>
        Precision
      </span>
      <div className="flex items-center gap-2 mt-1">
        <span className={`inline-block h-px w-4 ${hairline}`} />
        <span className={`font-display font-semibold uppercase tracking-[0.28em] text-[9px] md:text-[10px] ${gold}`}>
          Contracting Network
        </span>
      </div>
    </div>
  );
}
